import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("b", { style: {"font-weight":"600"} }, "Bankgarantie", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", null, "De 5%-regeling is het wettelijke recht van de koper van een nieuwbouwwoning om bij de oplevering 5% van de aanneemsom vast te houden bij de notaris. Vindt u bij de oplevering of in de eerste 3 maanden na de oplevering opleverpunten en heeft de aannemer deze gebreken niet herstelt of heeft u er geen vertrouwen in dat dit opgelost gaat worden, dan heeft u de mogelijkheid om (een deel van) de uitkering van deze 5% vast te houden als zekerheidstelling. De onderhouds- en garantiepunten vallen buiten deze regeling.", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, "Bij de oplevering heeft de aannemer hiervoor een bankgarantie gesteld bij Jager Notarissen te Heemstede. Dit houdt in dat de bank garant staat voor 5% van de aanneemsom als de aannemer zijn verplichtingen niet nakomt. Op dit moment staat er nog een bedrag ter hoogte van 5% in depot bij de notaris.", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", null, "Drie maanden na oplevering vervalt automatisch de bankgarantie, tenzij u aangeeft dat u deze wilt handhaven. In dit geval dient u tijdig aan te geven tot welk bedrag dit moet worden gehandhaafd. Dit bedrag moet in ‘redelijke verhouding’ staan tot de nog aanwezige gebreken.", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", null, "Wij wijzen u erop dat, als u onterecht gebruik maakt van uw opschortingsrecht of als er een te hoog bedrag vastgehouden wordt, u een schadevergoeding verschuldigd kan worden. De schadevergoeding is vastgesteld op de wettelijke rente over het bedrag dat de koper na drie maanden na de oplevering tot de dag der voldoening ten onrechte heeft opgeschort.", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", { class: "no-mb" }, "Vul hieronder duidelijk in op welke punten u de bankgarantie vasthoudt.", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", null, "Wilt u (een gedeelte) van de bankgarantie vasthouden?", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createTextVNode("Reden van vasthouden "),
  /*#__PURE__*/_createElementVNode("span", { class: "required-label" }, "*")
], -1)
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("h4", null, "Weet u zeker dat u (een gedeelte van) de bankgarantie wilt vasthouden?", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("p", null, "Het onterecht vasthouden van (een gedeelte van) de bankgarantie brengt kosten met zich mee.", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("p", { class: "no-mb" }, "Als u zeker weet dat u (een gedeelte van) de bankgarantie wilt vasthouden kunt u dat doen door ter bevestiging uw geboortedatum, geboorteplaats en laatste 4 cijfers van uw BSN-nummer in te vullen.", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", null, "Geboortedatum", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", null, "Geboorteplaats", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", null, "Laatste 4 cijfers van uw BSN-nummer", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("h4", null, "Weet u zeker dat u het vast te houden bedrag wilt aanpassen?", -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("p", null, "Het onterecht vasthouden van (een gedeelte van) de bankgarantie brengt kosten met zich mee.", -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("p", { class: "no-mb" }, "Als u zeker weet dat u het vast te houden bedrag wilt aanpassen kunt u dat doen door het nieuwe vast te houden bedrag + reden in te vullen en ter bevestiging uw geboortedatum, geboorteplaats en laatste 4 cijfers van uw BSN-nummer in te vullen.", -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createTextVNode("Nieuw bedrag "),
  /*#__PURE__*/_createElementVNode("span", { class: "required-label" }, "*")
], -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createTextVNode("Reden van vasthouden "),
  /*#__PURE__*/_createElementVNode("span", { class: "required-label" }, "*")
], -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createTextVNode("Geboortedatum "),
  /*#__PURE__*/_createElementVNode("span", { class: "required-label" }, "*")
], -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createTextVNode("Geboorteplaats "),
  /*#__PURE__*/_createElementVNode("span", { class: "required-label" }, "*")
], -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createTextVNode("Laatste 4 cijfers van uw BSN-nummer "),
  /*#__PURE__*/_createElementVNode("span", { class: "required-label" }, "*")
], -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("h4", null, "Weet u zeker dat u de bankgarantie wilt vrijgeven?", -1)
const _hoisted_32 = /*#__PURE__*/_createElementVNode("p", { class: "no-mb" }, "Als u zeker weet dat u de bankgarantie wilt vrijgeven kunt u dat doen door ter bevestiging uw geboortedatum, geboorteplaats en laatste 4 cijfers van uw BSN-nummer in te vullen.", -1)
const _hoisted_33 = /*#__PURE__*/_createElementVNode("label", null, "Geboortedatum", -1)
const _hoisted_34 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_35 = /*#__PURE__*/_createElementVNode("label", null, "Geboorteplaats", -1)
const _hoisted_36 = /*#__PURE__*/_createElementVNode("label", null, "Laatste 4 cijfers van uw BSN-nummer", -1)
const _hoisted_37 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

import { headerStore } from '@/stores/header'
import { onMounted, ref } from 'vue'
import axios from 'axios'
import { authStore } from '@/stores/auth'
import { notification } from 'ant-design-vue'
import TextEditor from '@/components/service/TextEditor.vue'
import dayjs from 'dayjs'

interface FivePercentRule {
  id: number
  enabled: boolean
  hold: boolean
  hold_reason: string
  hold_amount: number
  hold_at: string|null
  max_hold_amount: number
  releasable_from: string|null
  released_at: string|null
}


export default /*#__PURE__*/_defineComponent({
  __name: 'FivePercentRulePanel',
  setup(__props) {

const loading = ref(false)
const fivePercentRule = ref<FivePercentRule|null>(null)

const showConfirmHoldModal = ref(false)
const showChangeAmountModal = ref(false)
const showConfirmReleaseModal = ref(false)

const newAmount = ref<number|null>(null)
const newAmountReason = ref<string|null>(null)

const confirmData = ref<{ dateOfBirth:string|null, cityOfBirth:string|null, bsn:string|null }>({
  dateOfBirth: null,
  cityOfBirth: null,
  bsn: null
})

onMounted(() => {
  if (headerStore().buildingDelivered) {
    getFivePercentDetails()
  }
})

function getFivePercentDetails () : void {
  axios.get(process.env.VUE_APP_API_URL + '/fivePercent').then((r) => {
    fivePercentRule.value = r.data.data || null
  })
}

function toggleConfirmHoldModal () : void {
  showConfirmHoldModal.value = !showConfirmHoldModal.value
  confirmData.value = {
    dateOfBirth: null,
    cityOfBirth: null,
    bsn: null
  }
}

function holdFivePercent () : void {
  if (!fivePercentRule.value) return

  loading.value = true
  axios.post(process.env.VUE_APP_API_URL + '/fivePercent/' + fivePercentRule.value.id + '/hold', {
    fivePercentRule: fivePercentRule.value,
    confirmData: {
      dateOfBirth: confirmData.value.dateOfBirth ? dayjs(confirmData.value.dateOfBirth).format('YYYY-MM-DD HH:mm:ss') : null,
      cityOfBirth: confirmData.value.cityOfBirth,
      bsn: confirmData.value.bsn
    }
  }).then((r) => {
    fivePercentRule.value = r.data.data || null
    toggleConfirmHoldModal()
    notification.success({
      message: 'Bankgarantie wordt vastgehouden.',
      description: 'U heeft aangegeven (een gedeelte van) de bankgarantie vast te willen houden. Dit verzoek is succesvol door ons ontvangen.',
      duration: 10
    })
  }).catch(() => {
    notification.error({
      message: 'Fout tijdens vasthouden bankgarantie!',
      description: 'Er is helaas iets mis gegaan. Probeer het later nog een keer.',
      duration: 0
    })
  }).finally(() => {
    loading.value = false
  })
}

function toggleChangeAmountModal () : void {
  showChangeAmountModal.value = !showChangeAmountModal.value
  newAmount.value = null
  newAmountReason.value = null
  confirmData.value = {
    dateOfBirth: null,
    cityOfBirth: null,
    bsn: null
  }
}

function changeAmount () : void {
  if (!fivePercentRule.value) return

  loading.value = true
  axios.post(process.env.VUE_APP_API_URL + '/fivePercent/' + fivePercentRule.value.id + '/change', {
    newHoldAmount: newAmount.value,
    newHoldReason: newAmountReason.value,
    newConfirmData: {
      dateOfBirth: confirmData.value.dateOfBirth ? dayjs(confirmData.value.dateOfBirth).format('YYYY-MM-DD HH:mm:ss') : null,
      cityOfBirth: confirmData.value.cityOfBirth,
      bsn: confirmData.value.bsn
    }
  }).then((r) => {
    fivePercentRule.value = r.data.data || null
    toggleChangeAmountModal()
    notification.success({
      message: 'Hoogte bankgarantie aangepast.',
      description: 'U heeft de hoogte van de bankgarantie aangepast. U ontvangt z.s.m. een bevestiging.',
      duration: 10
    })
  }).catch(() => {
    notification.error({
      message: 'Fout tijdens aanpassen bankgarantie!',
      description: 'Er is helaas iets mis gegaan. Probeer het later nog een keer.',
      duration: 0
    })
  }).finally(() => {
    loading.value = false
  })
}

function toggleConfirmReleaseModal () : void {
  showConfirmReleaseModal.value = !showConfirmReleaseModal.value
  confirmData.value = {
    dateOfBirth: null,
    cityOfBirth: null,
    bsn: null
  }
}

function releaseFivePercent () : void {
  if (!fivePercentRule.value) return

  loading.value = true
  axios.post(process.env.VUE_APP_API_URL + '/fivePercent/' + fivePercentRule.value.id + '/release', {
    fivePercentRule: fivePercentRule.value,
    confirmData: {
      dateOfBirth: confirmData.value.dateOfBirth ? dayjs(confirmData.value.dateOfBirth).format('YYYY-MM-DD HH:mm:ss') : null,
      cityOfBirth: confirmData.value.cityOfBirth,
      bsn: confirmData.value.bsn
    }
  }).then((r) => {
    fivePercentRule.value = r.data.data || null
    toggleConfirmHoldModal()
    notification.success({
      message: 'Bankgarantie vrijgegeven.',
      description: 'U heeft de bankgarantie vrijgegeven. Dank hiervoor. U ontvangt z.s.m. een bevestiging.',
      duration: 10
    })
  }).catch(() => {
    notification.error({
      message: 'Fout tijdens vrijgeven bankgarantie!',
      description: 'Er is helaas iets mis gegaan. Probeer het later nog een keer.',
      duration: 0
    })
  }).finally(() => {
    loading.value = false
  })
}

return (_ctx: any,_cache: any) => {
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_input_number = _resolveComponent("a-input-number")!
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_date_picker = _resolveComponent("a-date-picker")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_modal = _resolveComponent("a-modal")!
  const _component_a_collapse_panel = _resolveComponent("a-collapse-panel")!
  const _component_a_collapse = _resolveComponent("a-collapse")!

  return (!_unref(authStore)().isDemoCustomer && _unref(headerStore)().buildingDelivered && fivePercentRule.value && fivePercentRule.value.enabled)
    ? (_openBlock(), _createBlock(_component_a_collapse, {
        key: 0,
        style: { borderTop: 0 }
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_collapse_panel, null, {
            header: _withCtx(() => [
              _hoisted_1
            ]),
            default: _withCtx(() => [
              _createVNode(_component_a_row, { gutter: [16,16] }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, { span: 24 }, {
                    default: _withCtx(() => [
                      _hoisted_2,
                      _hoisted_3,
                      _hoisted_4,
                      _hoisted_5,
                      _hoisted_6
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_a_row, { gutter: [16,16] }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, { span: 24 }, {
                    default: _withCtx(() => [
                      _hoisted_7,
                      _hoisted_8,
                      _createVNode(_component_a_checkbox, {
                        style: {"font-weight":"400"},
                        disabled: fivePercentRule.value.hold_at !== null,
                        checked: fivePercentRule.value.hold,
                        "onUpdate:checked": _cache[1] || (_cache[1] = ($event: any) => ((fivePercentRule.value.hold) = $event))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Ja, ik wil "),
                          _createVNode(_component_a_input_number, {
                            "addon-before": "€",
                            size: "small",
                            min: 0,
                            max: fivePercentRule.value.max_hold_amount,
                            precision: 2,
                            decimalSeparator: ",",
                            controls: false,
                            disabled: fivePercentRule.value.hold_at !== null,
                            value: fivePercentRule.value.hold_amount,
                            "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((fivePercentRule.value.hold_amount) = $event))
                          }, null, 8, ["max", "disabled", "value"]),
                          _createTextVNode(" van de bankgarantie vasthouden. ")
                        ]),
                        _: 1
                      }, 8, ["disabled", "checked"])
                    ]),
                    _: 1
                  }),
                  (fivePercentRule.value.hold)
                    ? (_openBlock(), _createBlock(_component_a_col, {
                        key: 0,
                        span: 24
                      }, {
                        default: _withCtx(() => [
                          _hoisted_9,
                          (!fivePercentRule.value.hold_at)
                            ? (_openBlock(), _createBlock(TextEditor, {
                                key: 0,
                                content: fivePercentRule.value.hold_reason,
                                onContentChange: _cache[2] || (_cache[2] = ($event: any) => (fivePercentRule.value.hold_reason = $event))
                              }, null, 8, ["content"]))
                            : (_openBlock(), _createElementBlock("div", {
                                key: 1,
                                innerHTML: fivePercentRule.value.hold_reason
                              }, null, 8, _hoisted_10))
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              _createVNode(_component_a_row, {
                gutter: [16,16],
                class: "no-mb"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, { span: 24 }, {
                    default: _withCtx(() => [
                      (fivePercentRule.value.hold_at === null)
                        ? (_openBlock(), _createBlock(_component_a_button, {
                            key: 0,
                            type: "primary",
                            disabled: !fivePercentRule.value.hold || !fivePercentRule.value.hold_amount || !fivePercentRule.value.hold_reason || _unref(authStore)().restricted(),
                            onClick: toggleConfirmHoldModal
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Bevestigen")
                            ]),
                            _: 1
                          }, 8, ["disabled"]))
                        : _createCommentVNode("", true),
                      (fivePercentRule.value.hold_at !== null)
                        ? (_openBlock(), _createBlock(_component_a_button, {
                            key: 1,
                            style: {"margin-right":"8px"},
                            onClick: toggleChangeAmountModal,
                            disabled: _unref(authStore)().restricted()
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Bedrag aanpassen")
                            ]),
                            _: 1
                          }, 8, ["disabled"]))
                        : _createCommentVNode("", true),
                      (fivePercentRule.value.hold_at !== null && new Date() >= new Date(fivePercentRule.value.releasable_from))
                        ? (_openBlock(), _createBlock(_component_a_button, {
                            key: 2,
                            type: "primary",
                            disabled: _unref(authStore)().restricted(),
                            onClick: toggleConfirmReleaseModal
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Volledig vrijgeven")
                            ]),
                            _: 1
                          }, 8, ["disabled"]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_a_modal, {
                title: "Vasthouden bankgarantie.",
                "cancel-text": "Annuleren",
                "ok-text": "Bevestigen",
                "ok-button-props": { disabled: !confirmData.value.dateOfBirth || !confirmData.value.cityOfBirth || !confirmData.value.bsn || confirmData.value.bsn.length !== 4 || loading.value, loading: loading.value },
                visible: showConfirmHoldModal.value,
                onOk: holdFivePercent,
                onCancel: toggleConfirmHoldModal
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_col, { span: 24 }, {
                        default: _withCtx(() => [
                          _hoisted_11,
                          _hoisted_12,
                          _hoisted_13
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_col, { span: 24 }, {
                        default: _withCtx(() => [
                          _hoisted_14,
                          _hoisted_15,
                          _createVNode(_component_a_date_picker, {
                            style: {"width":"100%"},
                            format: "DD-MM-YYYY",
                            value: confirmData.value.dateOfBirth,
                            "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((confirmData.value.dateOfBirth) = $event))
                          }, null, 8, ["value"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_col, { span: 24 }, {
                        default: _withCtx(() => [
                          _hoisted_16,
                          _createVNode(_component_a_input, {
                            type: "text",
                            value: confirmData.value.cityOfBirth,
                            "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((confirmData.value.cityOfBirth) = $event))
                          }, null, 8, ["value"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_row, { class: "no-mb" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_col, { span: 24 }, {
                        default: _withCtx(() => [
                          _hoisted_17,
                          _hoisted_18,
                          _createVNode(_component_a_input, {
                            type: "string",
                            value: confirmData.value.bsn,
                            "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((confirmData.value.bsn) = $event))
                          }, null, 8, ["value"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["ok-button-props", "visible"]),
              _createVNode(_component_a_modal, {
                title: "Bedrag bankgarantie aanpassen.",
                "cancel-text": "Annuleren",
                "ok-text": "Bevestigen",
                "ok-button-props": { disabled: !newAmount.value || newAmount.value >= fivePercentRule.value.max_hold_amount || !newAmountReason.value || !confirmData.value.dateOfBirth || !confirmData.value.cityOfBirth || !confirmData.value.bsn || confirmData.value.bsn.length !== 4 || loading.value, loading: loading.value },
                visible: showChangeAmountModal.value,
                onOk: changeAmount,
                onCancel: toggleChangeAmountModal
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_col, { span: 24 }, {
                        default: _withCtx(() => [
                          _hoisted_19,
                          _hoisted_20,
                          _hoisted_21
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_col, { span: 24 }, {
                        default: _withCtx(() => [
                          _hoisted_22,
                          _hoisted_23,
                          _createVNode(_component_a_input_number, {
                            style: {"width":"100%"},
                            "addon-before": "€",
                            min: 1,
                            max: fivePercentRule.value.max_hold_amount,
                            precision: 2,
                            decimalSeparator: ",",
                            controls: false,
                            value: newAmount.value,
                            "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((newAmount).value = $event))
                          }, null, 8, ["max", "value"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_col, { span: 24 }, {
                        default: _withCtx(() => [
                          _hoisted_24,
                          _hoisted_25,
                          _createVNode(TextEditor, {
                            content: newAmountReason.value,
                            onContentChange: _cache[7] || (_cache[7] = ($event: any) => (newAmountReason.value = $event))
                          }, null, 8, ["content"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_col, { span: 24 }, {
                        default: _withCtx(() => [
                          _hoisted_26,
                          _hoisted_27,
                          _createVNode(_component_a_date_picker, {
                            style: {"width":"100%"},
                            format: "DD-MM-YYYY",
                            value: confirmData.value.dateOfBirth,
                            "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((confirmData.value.dateOfBirth) = $event))
                          }, null, 8, ["value"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_col, { span: 24 }, {
                        default: _withCtx(() => [
                          _hoisted_28,
                          _createVNode(_component_a_input, {
                            type: "text",
                            value: confirmData.value.cityOfBirth,
                            "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((confirmData.value.cityOfBirth) = $event))
                          }, null, 8, ["value"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_row, { class: "no-mb" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_col, { span: 24 }, {
                        default: _withCtx(() => [
                          _hoisted_29,
                          _hoisted_30,
                          _createVNode(_component_a_input, {
                            type: "string",
                            value: confirmData.value.bsn,
                            "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((confirmData.value.bsn) = $event))
                          }, null, 8, ["value"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["ok-button-props", "visible"]),
              _createVNode(_component_a_modal, {
                title: "Vrijgeven bankgarantie.",
                "cancel-text": "Annuleren",
                "ok-text": "Vrijgeven",
                "ok-button-props": { disabled: !confirmData.value.dateOfBirth || !confirmData.value.cityOfBirth || !confirmData.value.bsn || confirmData.value.bsn.length !== 4 || loading.value, loading: loading.value },
                visible: showConfirmReleaseModal.value,
                onOk: releaseFivePercent,
                onCancel: toggleConfirmReleaseModal
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_col, { span: 24 }, {
                        default: _withCtx(() => [
                          _hoisted_31,
                          _hoisted_32
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_col, { span: 24 }, {
                        default: _withCtx(() => [
                          _hoisted_33,
                          _hoisted_34,
                          _createVNode(_component_a_date_picker, {
                            style: {"width":"100%"},
                            format: "DD-MM-YYYY",
                            value: confirmData.value.dateOfBirth,
                            "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((confirmData.value.dateOfBirth) = $event))
                          }, null, 8, ["value"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_col, { span: 24 }, {
                        default: _withCtx(() => [
                          _hoisted_35,
                          _createVNode(_component_a_input, {
                            type: "text",
                            value: confirmData.value.cityOfBirth,
                            "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((confirmData.value.cityOfBirth) = $event))
                          }, null, 8, ["value"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_row, { class: "no-mb" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_col, { span: 24 }, {
                        default: _withCtx(() => [
                          _hoisted_36,
                          _hoisted_37,
                          _createVNode(_component_a_input, {
                            type: "string",
                            value: confirmData.value.bsn,
                            "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => ((confirmData.value.bsn) = $event))
                          }, null, 8, ["value"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["ok-button-props", "visible"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})